<template functional>
    <!-- Case.1 String -->
    <component v-if="props.field.type==='string'"
            :is="$options.components.gridTextField" 
            :value="props.value" @input="(v)=>{$options.onInput(v,props,listeners,injections)}"
            @focus="()=>{$options.onFocus(listeners, injections)}"
            @blur ="()=>{$options.applyRule(listeners, injections)}"
            @keydown ="()=>{$options.onKeyDown(injections)}" />
    <!-- Case.2 Number -->
    <component v-else-if="props.field.type==='number'"
            :is="$options.components.gridStepper" 
            :value="props.value" @input="(v)=>{$options.onInput(v,props,listeners,injections)}"
            @focus="()=>{$options.onFocus(listeners, injections)}"
            @blur ="()=>{$options.applyRule(listeners, injections)}"
            @keydown ="(e)=>{$options.onKeyDown(injections)}"
            @num:clicked="()=>{$options.applyRule(listeners, injections)}"
            :min="props.field.min" :max="props.field.max"/>
    <!-- Case.3 Date -->
    <component v-else-if="props.field.type==='date'"
            :is="$options.components.gridDatePicker" 
            :value="props.value" @input="(v)=>{$options.onInput(v,props,listeners,injections)}"
            :return-type="injections.gridInfo.opts.dateReturnType"
            @focus="()=>{$options.onFocus(listeners, injections)}"
            @blur ="()=>{$options.applyRule(listeners, injections)}"
            @keydown ="(e)=>{$options.onKeyDown(injections)}"
            @picker:confirm="()=>{$options.applyRule(listeners, injections)}"
            @on-flotage="(v)=>{$options.toggleFlotage(v,listeners, injections)}"
            :min-date="props.field.min" :max-date="props.field.max" attach-root
            :date-format="injections.gridInfo.opts.dateEditFormat"
            :timezone="$options.getTimezone(props, injections)"
            :msg-today  ="injections.gridInfo.opts.msgCalendarToday"
            :msg-confirm="injections.gridInfo.opts.msgCalendarConfirm"/>
    <!-- Case.4 Boolean -->
    <component v-else-if="props.field.type==='boolean'"
            :is="$options.components.gridCheckbox" 
            :value="props.value" @input="(v)=>{$options.onInput(v,props,listeners,injections)}"
            @focus="()=>{$options.onFocus(listeners, injections)}"
            @blur ="()=>{$options.applyRule(listeners, injections)}"/>
    <!-- Case.5 Code -->
    <!-- Case.5-1 Code with domain -->
    <component v-else-if="props.field.type==='code' && !!props.field.domain"
            :is="$options.components.gridDropdown" 
            :value="props.value" 
            @input="(v)=>{$options.resetRule(listeners);$options.onInput(v,props,listeners,injections)}"
            @focus="()=>{$options.onFocus(listeners, injections)}"
            @blur ="()=>{$options.applyRule(listeners, injections)}"
            @on-flotage="(v)=>{$options.toggleFlotage(v,listeners,injections)}"
            :items="$options.getDomain(props, injections)" attach-root/>
    <!-- Case.5-2 Code without -->
    <component v-else-if="props.field.type==='code' &&  !props.field.domain"
            :is="$options.components.gridTextField" 
            :value="props.value" @input="(v)=>{$options.onInput(v,props,listeners,injections)}"
            @focus="()=>{$options.onFocus(listeners, injections)}"
            @blur ="()=>{$options.applyRule(listeners, injections)}"
            @keydown ="(e)=>{$options.onKeyDown(injections)}"/>
    <!-- Case.x Default -->
    <component v-else
            :is="$options.components.gridTextField" 
            :value="props.value" @input="(v)=>{$options.onInput(v,props,listeners,injections)}"
            @focus="()=>{$options.onFocus(listeners, injections)}"
            @blur ="()=>{$options.applyRule(listeners, injections)}"
            @keydown ="(e)=>{$options.onKeyDown(injections)}"/>
</template>

<script>
import gridTextField  from "../../../edit/urDataGridEditTextField.vue";
import gridDatePicker from "../../../edit/urDataGridEditDatePicker.vue";
import gridDropdown   from "../../../edit/urDataGridEditDropdown.vue";
import gridStepper    from "../../../edit/urDataGridEditStepper.vue";
import gridCheckbox   from "../../../edit/urDataGridEditCheckbox.vue";


export default {
    name : "urDataGridContentCellEdit",
    inject : ['gridInfo', 'rowInfo'],
    props : {
        field : {type:Object},
        value : null /* type any */
    },
    // =======================================
    // FUNCTIONAL - Components
    components : {
        gridTextField,
        gridDatePicker,
        gridStepper,
        gridDropdown,
        gridCheckbox
    },
    // =======================================
    // FUNCTIONAL - METHODS
    //onInput({v,props,listeners,injections}) {
    onInput(v,props,$l,ij) {
        const row  = ij.rowInfo.row,
              opts = ij.gridInfo.opts,
              func = ij.gridInfo.func;
        if(opts.cellEdit) {
            func.cellTempValue(v);
        } else if(opts.rowEdit && row.__editMode) {
            ij.gridInfo.vars_currEditRow[props.field.value] = v;
        }
        if($l.input) {$l.input(v)}
    },
    applyRule($l,ij){
        if(ij.gridInfo.opts.manualValid) return;
        this.resetRule($l);
        if($l.applyRule) {$l.applyRule()}
    },
    getDomain(props, ij) {
        const slicer = props.field.domainSlicer;
        const domain = props.field.domain;
        if(typeof slicer === 'function') {
            return slicer(domain,ij.rowInfo.row);
        } else {
            return domain;
        }
    },
    resetRule($l){if($l.resetRule) {$l.resetRule()}},
    onFocus($l, ij){
        if($l.resetRule) {$l.resetRule()}
        ij.gridInfo.refs.pseudoScroll.adjustScroll();
    },
    onKeyDown(ij){
        ij.gridInfo.refs.pseudoScroll.adjustScroll();
    },
    toggleFlotage(v, $l, ij) {
      if(v){
        this.resetRule($l);
      }else{
        this.applyRule($l,ij);
      }
      ij.gridInfo.func.setCellFlotage(v)
    },
    getTimezone(props, ij) {
        return props.field.timezone === null ? ij.gridInfo.opts.timezone : props.field.timezone ;
    }
}
</script>